var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useCallback } from 'react';
export function useIntersectionObserver(callback, options, deps) {
  if (options === void 0) {
    options = {};
  }
  if (deps === void 0) {
    deps = [];
  }
  var observerRef = useRef();
  var latestCallback = useRef(callback);
  useEffect(function () {
    latestCallback.current = callback;
  }, [callback]);
  var observerFactory = useCallback(function () {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      return new IntersectionObserver(function (entries, intersection) {
        latestCallback.current(entries, intersection);
        if (entries && options.triggerOnce) {
          intersection.disconnect();
        }
      }, {
        root: options.root,
        rootMargin: options.rootMargin,
        threshold: options.threshold
      });
    }
  }, [options.threshold, options.root, options.rootMargin, options.triggerOnce]);
  var setRef = useCallback(function (node) {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }
    if (node) {
      observerRef.current = observerFactory();
      observerRef.current && observerRef.current.observe(node);
    }
  }, __spreadArray([observerFactory], __read(deps), false));
  // clear everything on unmount
  useEffect(function () {
    return function () {
      observerRef.current && observerRef.current.disconnect();
    };
  }, []);
  return [setRef];
}